import React, {useState} from 'react';
import {Text,View,ActivityIndicator} from 'react-native';
import { AntDesign } from '@expo/vector-icons'; 



export default function dadosbancarios({route,navigation}){
    const [loading, setLoading] = useState(true);
    const [Tel, setTel] = React.useState([]);
    const [Nome, setNome] = React.useState([]);
    

var validatinoApi ='https://emprestimoimperion.com/composer/controller/api/dadospessoais.php';
var headers={
   'Accept':'application/json',
   'Content-Type':'application.json',
   'Access-Control-Allow-Methods': 'POST',
   'Access-Control-Allow-Origin':'*',
   'crossDomain': 'true',
   'Host': 'https://emprestimoimperion.com/composer/controller/api/dadospessoais.php',
   'Access-Control-Allow-Credentials': 'true'
   
    };
   /*'crossDomain': 'true',*/
    var Data={       
    id:route.params.userid,
    token:route.params.id,
    };

    fetch(validatinoApi,
    {
    method:'POST',
    headers:headers,
    body:JSON.stringify(Data)
    }).then((response)=>response.json())
    .then((response)=>{
    if(response.statusCode==200){
       setTel(response.tel)
       setNome(response.nome)
       setLoading(false);
    }else{
    alert('Algo errado com usuario ou senha');
    setLoading(false);
    } 
    }).catch((error)=>{
    console.log(error);
    setLoading(false);
    });

return(
<View style={{backgroundColor:'#01150E',height:'100%'}}>
<View style={{alignItems:'center'}}>
<Text style={{fontSize:20,color:'white',margin:10}}>Dados Pessoais</Text>
</View>
<View style={{margin:20,borderBottomWidth:1,borderColor:'white'}}><Text style={{color:'white',fontSize:15}}>{Tel}</Text>
{loading?(<ActivityIndicator color="white" size={40} />) : null}
<Text style={{color:'white',margin:10}}>Telefone</Text>
</View>
<View style={{margin:20,borderBottomWidth:1,borderColor:'white'}}><Text style={{color:'white',fontSize:15}}>{Nome}</Text>
<Text style={{color:'white',margin:10}}>Nome</Text>
</View>
<View style={{alignItems: 'flex-end',margin:20}}>
<AntDesign name="edit" size={40} color="white"  onPress = {() => {navigation.navigate('Cadastro_Pessoal',{id:route.params.id,userid:route.params.userid})}}/>
</View>
</View>
);

}